import AnimatedPopup from "../core/AnimatedPopup";
import Strings from "../core/data/Strings";
import GameScene from "../scenes/GameScene";
import ARIA from "../utils/ARIA";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";
import Overlay from "../utils/Overlay";

export class GameCompletePopup extends AnimatedPopup {
	private _onResize: () => void;
	scene: GameScene;
	particles: Phaser.GameObjects.Image[] = [];
	onNext: () => void;
	onNextContext: CallbackContext;
	constructor(scene: GameScene, onNext: () => void, onNextContext: CallbackContext) {
		super(scene, 0, 0);
		this.scene = scene;
		this.onNext = onNext;
		this.onNextContext = onNextContext;
		const overlay = (this._overlay = new Overlay(scene, 0.7, "popupOverlay", 0xffffff));
		this.add(overlay);
		const emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

		for (const img of ["fallingSnow1", "fallingSnow2", "fallingSnow3"]) {
			const particle = this.scene.add.particles(img);
			this.particles.push();
			const emitter = particle.createEmitter({
				alpha: { start: 1, end: 0.0 },
				scale: { min: 0.7, max: 1 },
				frequency: 300,
				lifespan: 2500,
				gravityY: 300,
				speedX: { min: -50, max: 300 },
				speedY: { min: 150, max: 400 },
			});
			const topLeft = this.scene.viewport.getTopLeft();
			const topRight = this.scene.viewport.getTopRight();
			emitter.setPosition({ min: -topLeft.x, max: topRight.x }, { min: topLeft.y - 20, max: topLeft.y - 20 });

			emitters.push(emitter);
			emitter.start();
			this.add(particle);
		}

		const popupGroup = (this._popupGroup = this.scene.add.container());
		this.add(popupGroup);

		const popup = scene.add.nineSlicedSprite(0, 0, "popupBG", 1325, 920, 50, 50, 50, 50, null, false);
		popupGroup.add(popup);
		popupGroup.setSize(popup.slicedWidth, popup.slicedHeight);

		const textBacker = scene.add.image(0, 0, "lightBacker");
		popupGroup.add(textBacker);

		const descText = scene.add.text(0, 0, Strings.get("GameComplete"), {
			color: "#686ab5",
			fontFamily: Fonts.MontserratExtraBold,
			fontSize: "30px",
			align: "center",
			wordWrap: { width: 850 },
		});
		descText.setLineSpacing(20);
		popupGroup.add(descText);

		const img = scene.add.image(0, 0, "completeImage");
		popupGroup.add(img);

		const leftDeco = scene.add.image(0, 0, "completeDecoLeft");
		const rightDeco = scene.add.image(0, 0, "completeDecoRight");

		popupGroup.add([leftDeco, rightDeco]);

		const headerBG = scene.add.image(0, 0, "popupHeader");
		const headerText = this.scene.add.text(0, 0, Strings.get("GreatWork").toUpperCase(), {
			color: GameColors.WHITE,
			fontSize: "70px",
			fontFamily: Fonts.MontserratExtraBold,
			align: "center",
		});
		popupGroup.add([headerBG, headerText]);
		this.scene.alignIn.TopCenter(headerText, popup, 0, -25);

		const button = scene.add.button(0, 0, "nextBtn", null, this.onNext, this.onNextContext, true);
		popupGroup.add(button);

		this._onResize = (): void => {
			scene.alignIn.Center(popupGroup, scene.viewport);
			scene.alignIn.TopCenter(headerBG, popup, 0, headerBG.height / 2);
			scene.alignIn.Center(headerText, headerBG, 0, 0);
			scene.alignIn.Center(descText, popup, 0, 50);
			scene.alignIn.Center(textBacker, descText, 0, 0);

			scene.alignIn.TopCenter(img, popup, 0, 80);
			scene.alignIn.BottomLeft(leftDeco, popup, 135, 20);
			scene.alignIn.BottomRight(rightDeco, popup, 190, 30);

			scene.alignTo.BottomCenter(button, popup, 0, -button.height * 0.75);
		};
		this.resize();

		const ariaLayer = "game-complete-popup";
		headerText.setARIA(ariaLayer, true);
		descText.setARIA(ariaLayer);
		button.setARIA("Next", ariaLayer);
		ARIA.showLayer(ariaLayer, true);

		this.intro();
	}

	resize(): void {
		if (this._onResize) this._onResize();
		super.resize();
	}
}
